import { formatQuantity } from '@kronos/domain'
import type { Receipt } from '../../data/inventory'
import { whenText } from './shared'

const SERIALS = 4

/**
 * An item's deliveries as a timeline: a line down the side, a mark for each
 * one, the amount large ("+22"), then when, who, the note, and the Kronos
 * numbers it was given. Read, not pressed — the units themselves are listed
 * below, each its own button.
 */
export function DeliveryTimeline({ receipts }: { receipts: readonly Receipt[] }): JSX.Element {
  return (
    <ol className="inv-timeline">
      {receipts.map((r) => {
        const meta = [whenText(r.receivedAt), r.receivedBy ? `by ${r.receivedBy}` : null].filter(Boolean).join(' · ')
        const makers = r.units.filter((u) => u.makerSerial !== null).length
        return (
          <li key={r.id} className="inv-timeline__entry">
            <span className="inv-timeline__dot" aria-hidden="true" />
            <div className="inv-timeline__card">
              <div className="inv-timeline__head">
                <span className="figure inv-timeline__qty">+{formatQuantity(r.quantity, r.unit)}</span>
                <span className="muted">{meta}</span>
              </div>
              {r.note ? <span className="inv-timeline__note">{r.note}</span> : null}
              {r.units.length > 0 ? (
                <span className="inv-timeline__serials">
                  {r.units.slice(0, SERIALS).map((u) => (
                    <span key={u.componentId} className="serial inv-serial-chip">
                      {u.serial}
                    </span>
                  ))}
                  {r.units.length > SERIALS ? <span className="muted">+{r.units.length - SERIALS} more</span> : null}
                  {makers > 0 ? (
                    <span className="muted">
                      · {makers} with maker’s serial{makers === 1 ? '' : 's'}
                    </span>
                  ) : null}
                </span>
              ) : null}
            </div>
          </li>
        )
      })}
    </ol>
  )
}
